module.exports = __webpack_public_path__ + "img/6c3f2c7.jpg";